/* eslint-disable camelcase */
<template>
  <div v-role="'func'">
    <div>
      <div class="formPosition">

        <v-card style="margin:auto;border:1px solid #006699;" width="1200">
          <v-container style="background-color:#006699; color:white;">
            <div>
              <v-icon v-if="$store.state.fromStock" @click="$router.push('Novo-Stock')"
                style="float:right;color:white;">arrow_back
              </v-icon>
            </div>
            <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
          </v-container>

          <!-- ========= DIALOGO INFORMATIVO ==================================== -->


          <!-- ============ MODAL - ADD NOVO PREÇO ================== -->
          <template>
            <v-row justify="center">
              <v-dialog v-model="dialogEmolumento" persistent max-width="500px">
                <v-card>
                  <v-overlay :value="overlayEmolumento">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                  <v-card-title>
                    <span class="headline">Novo Emolumento</span>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field :rules="ruleText" v-model="descricaoEmolumento"
                              label="Forneça a descrição do emolumento"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="color:white;" color="green darken-1" :disabled="!valid"
                      @click="saveEmolumento()">Guardar</v-btn>
                    <v-btn @click="dialogEmolumento = false">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ============= FIM DO MODAL NOVO PRECO =============== -->





          <!-- ======================== MODAL - ADD NOVO PREÇO =================== -->
          <template>
            <v-row justify="center">
              <v-dialog v-model="dialog" persistent max-width="800px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Novo Preço</span>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="12">
                            <v-text-field v-model="precoSemIva" v-money="money" @keyup="ObterPrecoDescricao()"
                              :rules=[ruleTextRequired] label="Preço de Venda"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="margemPreco" :rules="ruleNumberNObrigatorio"
                              label="Margem( % )"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="valorDescricao" :disabled="true"
                              label="Preço por compreensão"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select :items="taxa_iva" v-model="taxa_ivaPrecoSelected" item-value="percentagem"
                              item-text="descricao" @change="SelecionaIvaPreco()" filled label="IVA( % )*"></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select :items="descricao_isencao_ivaprecoFiltered" v-model="motivoIsencao"
                              item-text="descricao" :disabled="disabilita_ivaPreco" filled
                              label="Motivo de isenção*"></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="12">
                            <v-text-field :rule="ruleNumber" :disabled="true" v-model="precoComIva"
                              label="Preço com IVA"></v-text-field>
                            <v-switch v-model="predifinido" label="Predefinido"></v-switch>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="color:white;" color="green darken-1" :disabled="!valid"
                      @click="savePreco()">Guardar</v-btn>
                    <v-btn @click="dialog = false">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ==========================================FIM DO MODAL NOVO PRECO ============================================ -->
          <!-- ======================== MODAL - ADD NOVO PREÇO ============================================================== -->
          <template>
            <v-row justify="center">
              <v-dialog v-model="dialogTaxa" persistent max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Novo Taxa</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="10">
                          <v-select :items="items" :disabled="true" filled label="Taxa"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-btn :disabled="true" small fab dark color="indigo">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6" md="10">
                          <v-select :items="items" filled label="Descrição"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-btn small fab dark color="indigo">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field :disabled="true" label="Código"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field :disabled="true" label="Valor"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-switch label="Sujeito a IVA"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="8"></v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-switch label="Isento a IVA"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="8">
                          <v-select :items="items" :disabled="true" filled label="Não Definido"></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="color:white;" color="green darken-1" @click="dialogTaxa = false">Guardar</v-btn>
                    <v-btn @click="dialogTaxa = false">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ==========================================FIM DO MODAL ========================================= -->
          <!-- ======================== MODAL - ADD NOVO GRUPO-FAMILIA ======================================== -->
          <template>
            <v-row justify="center">
              <v-dialog v-model="dialogGrupo" persistent max-width="800px">
                <v-form ref="formg" v-model="validg" lazy-validation>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Novo Grupo/Familia</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="9">
                            <v-text-field v-model="editeItemGrupo.codigo" :rules="ruleRequired"
                              :disabled="!personalizar" label="Código"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-switch v-model="personalizar" label="Personalizar"></v-switch>
                          </v-col>
                          <v-col cols="12" sm="6" md="12">
                            <v-text-field v-model="editeItemGrupo.descricao" :rules="ruleRequired"
                              label="Nome"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" color="green darken-1" :disabled="!validg"
                        @click="SaveGrupo()">Guardar</v-btn>
                      <v-btn @click="dialogGrupo = false">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-row>
          </template>
          <!-- ==========================================FIM DO MODAL ========================================= -->


          <v-row>
            <v-col cols="12" sm="6" md="1"></v-col>
            <v-col cols="12" sm="6" md="8">
              <label>{{ (IsNegecioEscola) ? 'Selecione o emolumento' : 'Forneça o nome do Produto' }} <span
                  style="color:red;font-weight:bold;">*</span></label>
              <v-text-field outlined v-if="negocio !== 'Escola'" :rules="ruleRequired" v-model="descricaoProduto"
                label="Nome do Produto"></v-text-field>
              <v-combobox v-else :items="emolumentos" :rules="ruleRequired" item-text="descricao"
                v-model="emolumentoSelected" label="Emolumentos" @change="SelecionaEmolumento()" filled outlined
                return-object>
                <template v-slot:item="{ item }">
                  <v-list-item-avatar v-if="item.icone" color="indigo" class="headline font-weight-light white--text">
                    <v-btn icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.descricao"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-combobox>
            </v-col>
            <v-col md="2">

            </v-col>
          </v-row>
          <v-tabs v-model="tab" background-color="#006699" dark color="white">
            <v-tab v-for="item in items" :key="item.tab"
              :disabled="((item.id === 1 || item.id === 3) && !valid) || ((item.id === 1 || item.id === 3) && !valid1)"
              @click="TabIndexToZero(item.id)">
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <!-- <v-alert
          v-model="alert"
          dismissible
          :type="alertType"
          border="left"
          :icon="iconAlert"
          transition="scale-transition"
          :style="colorAlert"
          elevation="2"
          colored-border
        >
        {{msgAlert}}
          </v-alert> -->

          <div v-if="false" class="info_adm_container">
            O cadastro de emolumentos está disponível apenas para administradores do sistema.
            <br>Se você não é um administrador, por favor, entre em contato com a equipe de administração para obter
            assistência.
          </div>
          <v-tabs-items v-model="tab">
            <v-form ref="form" v-model="valid" lazy-validation>
              <!-- ================ PRIMEIRO TAB 1  GERAL ============ ======================================= -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-container>
                      <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">{{ $store.state.textMessage
                        }}
                      </div>
                      <table style="width:100%;">
                        <tr>
                          <td style="width:70%;">

                            <v-row>
                              <v-col cols="12" sm="6" md="6">
                                <v-select :items="tipoProdutos" item-text="descricao" item-value="pkTipoProduto"
                                  :rules="ruleRequired" v-model="tipoProdutoSelected" label="Tipo de Produto"
                                  @change="SelecionaTipoServico()" filled outlined></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="6" v-if="isAdmin">
                                <v-select v-model="mercadoriaSelected" :items="mercadoriasFiltered"
                                  :disabled="mercadoria_disable || isServicoSelected"
                                  :rules="(!isServicoSelected) ? ruleRequired : ''" item-value="pkMercadoria"
                                  item-text="mercadoria" label="Mercadoria" filled outlined></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="6" v-if="isAdmin">
                                <v-text-field outlined v-model="codigoBarraSelected" :disabled="isServicoSelected"
                                  @blur="VerificaCodigoExistente()" :rules="(!isServicoSelected) ? ruleNumber : ''"
                                  label="Código de barra"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6" v-if="isAdmin">
                                <v-select :items="armazem" v-model="armazemSelected"
                                  :rules="(!isServicoSelected) ? ruleRequired : ''" item-value="pkArmazem"
                                  :disabled="isServicoSelected" item-text="descricao" label="Armazém ou Loja disponível"
                                  filled outlined></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="6" v-if="isAdmin">
                                <v-text-field outlined :rules="ruleRequired" :disabled="IsNegecioEscola"
                                  v-model="descricaoReduzida" label="Descrição reduzida"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6" v-if="isAdmin">
                                <v-select :items="especificacao" v-model="especificacaoProdutoSelected"
                                  :rules="(!isServicoSelected) ? ruleRequired : ''" :disabled="isServicoSelected"
                                  item-value="pkArmazem" item-text="descricao" label="Especificação do Produto"
                                  @change="SelecionaEspecProduto()" filled outlined></v-select>
                              </v-col>
                            </v-row>
                            <span style="font-size:20px;font-weight:bold;" v-if="isAdmin">Família/Stock</span>
                            <div style="border:1px solid black;" v-if="isAdmin">
                              <v-row>
                                <v-col cols="12" sm="6" md="3">
                                  <v-select v-model="familiaSelected" item-value="pkFamiliaProduto"
                                    :items="familiaProduto" :rules="(!isServicoSelected) ? ruleRequired : ''"
                                    :disabled="isServicoSelected" item-text="descricao" label="Familia" filled
                                    outlined></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="1">
                                  <v-btn @click="showDialogGrupo()" class="btn_add_align" small fab dark color="indigo">
                                    <v-icon dark>add</v-icon>
                                  </v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-select v-model="controleStockSelected" item-value="id" :items="controleStock"
                                        :disabled="isServicoSelected" :rules="(!isServicoSelected) ? ruleRequired : ''"
                                        item-text="descricao" label="Controle de Stock" filled outlined
                                        @change="SelecionaControleStock()" v-bind="attrs" v-on="on"></v-select>
                                    </template>
                                    <span>Define o valor para receber um alerta de baixa de stock</span>
                                  </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field v-bind="attrs" v-on="on" outlined :disabled="disabledStocksFields"
                                        :rules="(controleStockSelected === 1 || isServicoSelected) ? '' : ruleNumber"
                                        v-model="stockMinimo" label="Stock Mínimo"></v-text-field>
                                    </template>
                                    <span>Define o valor para receber um alerta de baixa de stock</span>
                                  </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field outlined :disabled="disabledStocksFields" v-bind="attrs" v-on="on"
                                        :rules="(controleStockSelected === 1 || isServicoSelected) ? '' : ruleNumber"
                                        v-model="stockMaximo" label="Stock Máximo"></v-text-field>
                                    </template>
                                    <span>Define o valor para receber um alerta de excesso de stock</span>
                                  </v-tooltip>

                                </v-col>
                              </v-row>
                            </div>

                          </td>

                          <td v-if="isAdmin">
                            <table style="width:100%;">
                              <tr>
                                <td style="width:95%;">
                                  <div style="border:1px solid black;width:250px;height:170px;margin-left:26px;">
                                    <v-img style="width:250px;height:250px" :src="imageData" aspect-ratio="1.7"></v-img>
                                  </div>
                                </td>
                                <td>
                                  <input @change="previewImage" type="file" ref="file" style="display: none">
                                  <v-btn @click="$refs.file.click()" class="mx-2 btn_space" small fab dark
                                    color="primary">
                                    <v-icon dark>add_a_photo</v-icon>
                                  </v-btn>
                                  <v-btn @click="imageData = ''" class="mx-2 btn_space" small fab dark color="primary">
                                    <v-icon dark>remove</v-icon>
                                  </v-btn>

                                </td>
                              </tr>
                            </table>
                          </td>
                          <v-card-actions style="margin-top:210px;margin-left:50px;" v-if="isAdmin">
                            <v-btn style="color:white;" color="green darken-1"
                              :disabled="!valid || codigoRepetido || descricaoProduto === null"
                              @click="Continuar()">Continuar</v-btn>
                            <v-btn @click="resetValidation()">Limpar</v-btn>
                          </v-card-actions>
                          <v-card-actions v-if="!isAdmin">
                            <v-btn style="color:white;" color="green darken-1"
                              :disabled="!valid || codigoRepetido || descricaoProduto === null"
                              @click="Continuar()">Continuar</v-btn>
                            <v-btn @click="resetValidation()">Limpar</v-btn>
                          </v-card-actions>
                        </tr>
                      </table>
                    </v-container>
                  </v-card-text>

                </v-card>
              </v-tab-item>
            </v-form>
            <!-- ================ FIM - SEGUNDO TAB e Inicio 2 Tab ======================================= -->
            <v-tab-item>
              <v-card flat>

                <v-form ref="form1" v-model="valid1" lazy-validation>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" v-if="isAdmin">
                          <v-select :items="DefinirPrecoVenda" v-model="DefinirPrecoVendaSelected" item-text="descricao"
                            item-value="id" label="Definir Preço de venda" @change="SelecionaDefinirPrecoVenda()" filled
                            outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="isAdmin">
                          <v-select :items="Unidades" v-model="unidadeSelecionada" item-text="descricao" item-value="id"
                            label="Definir preço por:" @click="SelecionaUnidade()" return-object filled
                            outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isAdmin" >
                          <v-select :items="TipoPrecoVenda" v-model="tipoPrecoSelecionada" item-text="descricao"
                            :disabled="disabledPrecoFields" item-value="id" label="Calculo do Preço de venda"
                            @change="CalculoPrecoVenda()" filled outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" v-if="!disableMargem && isAdmin">
                          <v-text-field outlined v-model="custoCompra" :disabled="disableMargem || disabledPrecoFields"
                            v-money="money" :rules="ruleTextRequired" label="Custo do Produto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" v-if="!disableMargem && isAdmin">
                          <v-text-field outlined v-model="margemPrecoAutomatico" @blur="CalculoPrecoVendaAutomatico()"
                            :disabled="disableMargem || disabledPrecoFields" :rules="ruleNumberNObrigatorio"
                            label="Margem(%)de Lucro"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="disableMargem && showFieldPreco && isAdmin">
                          <v-text-field outlined v-model="margemPreco" :disabled="disableMargem || disabledPrecoFields"
                            :rules="(!Precoautomatico) ? '' : ruleNumberNObrigatorio"
                            label="Margem( % )"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="!disableMargem">
                          <v-text-field outlined v-model="precoSemIvaMargem"
                            :disabled="!disableMargem || disabledPrecoFields" @keyup="ObterPrecoDescricao()"
                            :rules="(DefinirPrecoVendaSelected === 1) ? '' : ruleTextRequired"
                            label="Preço de Venda"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-select v-if="regime_id !== '2' && regime_id !== '3'" :items="taxa_iva"
                            v-model="taxa_ivaPrecoSelected" item-value="percentagem" item-text="descricao"
                            @change="SelecionaIvaPreco()" filled outlined label="IVA( % )*"></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-select v-if="regime_id !== '2' && regime_id !== '3'"
                            :items="descricao_isencao_ivaprecoFiltered" v-model="motivoIsencao" item-text="descricao"
                            :rules="(disabilita_ivaPreco) ? ruleEmpty : ruleRequired" :disabled="disabilita_ivaPreco"
                            filled outlined return-object label="Motivo de isenção*"></v-select>
                        </v-col>

                        <!-- DEFINIR O TIPO DE PREÇO POR PERÍODO -->
                        <v-col cols="12" sm="6" md="8">
                          <v-select :items="definirPrecoPeriodo" v-model="definirPrecoPeriodoSelected"
                            item-text="descricao" item-value="id" label="Preço por período"
                            @change="SelecionaDefinirPrecoPeriodo()" filled outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4"></v-col>
                        <!-- FIM DEFINIR O TIPO DE PREÇO POR PERÍODO -->

                        <!-- PREÇO ÚNICO POR PERÍODO -->
                        <v-col cols="12" sm="6" md="4" v-if="(disableMargem && showFieldPreco) && isPrecoUnico">
                          <v-text-field outlined v-model="precoSemIva" :disabled="!disableMargem || disabledPrecoFields"
                            v-money="money" @keyup="ObterPrecoDescricao()" :rules="rulePrecoVenda"
                            label="Preço de Venda"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoUnico">
                          <v-text-field outlined v-model="valorDescricao"
                            :rules="(DefinirPrecoVendaSelected === 1) ? 1 : ruleRequired" :disabled="true"
                            label="Preço por compreensão"></v-text-field>
                        </v-col>
                        <!-- FIM PREÇO ÚNICO POR PERÍODO -->


                        <!-- DIFERENTES PREÇOS POR PERÍODO -->
                        <v-col cols="12" sm="6" md="4" v-if="(disableMargem && showFieldPreco) && isPrecoDiferente">
                          <v-text-field outlined v-model="precoManha" :disabled="!disableMargem || disabledPrecoFields"
                            v-money="money" @keyup="ObterPrecoDescricaoManha()" :rules="rulePrecoVenda"
                            label="Preço Período da manhã"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoDiferente">
                          <v-text-field outlined v-model="precoManhaDescricao"
                            :rules="(DefinirPrecoVendaSelected === 1) ? 1 : ruleRequired" :disabled="true"
                            label="Preço por compreensão"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoDiferente"></v-col>
                        <v-col cols="12" sm="6" md="4" v-if="(disableMargem && showFieldPreco) && isPrecoDiferente">
                          <v-text-field outlined v-model="precoTarde" :disabled="!disableMargem || disabledPrecoFields"
                            v-money="money" @keyup="ObterPrecoDescricaoTarde()" :rules="rulePrecoVenda"
                            label="Preço Período da tarde"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoDiferente">
                          <v-text-field outlined v-model="precoTardeDescricao"
                            :rules="(DefinirPrecoVendaSelected === 1) ? 1 : ruleRequired" :disabled="true"
                            label="Preço por compreensão"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoDiferente"></v-col>
                        <v-col cols="12" sm="6" md="4" v-if="(disableMargem && showFieldPreco) && isPrecoDiferente">
                          <v-text-field outlined v-model="precoNoite" :disabled="!disableMargem || disabledPrecoFields"
                            v-money="money" @keyup="ObterPrecoDescricaoNoite()" :rules="rulePrecoVenda"
                            label="Preço Período da noite"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoDiferente">
                          <v-text-field outlined v-model="precoNoiteDescricao"
                            :rules="(DefinirPrecoVendaSelected === 1) ? 1 : ruleRequired" :disabled="true"
                            label="Preço por compreensão"></v-text-field>
                        </v-col>
                        <!-- FIM DIFERENTES PREÇOS POR PERÍODO-->
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn style="color:white;" color="green darken-1" :disabled="!valid1 || !valid"
                    @click="Continuar2()">Continuar</v-btn>
                  <v-btn @click="tab = 0">Voltar</v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>

                <v-form ref="form2" v-model="valid2" lazy-validation>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" v-if="negocio !== 'Escola'">
                          <v-select :items="DefinirPrecoVenda" v-model="definirSubstituto" item-text="descricao"
                            item-value="id" label="Definir produto substituto?" outlined filled></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="8" v-if="definirSubstituto === 2">
                          <v-combobox v-model="produtoSubstitutoModel" :items="produtosSubstitutos" outlined filled
                            hide-selected item-text="produto" label="Selecione o(s) produto(s) substituto(s)" multiple
                            return-object @click="CarregaProdutos()">
                          </v-combobox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-combobox v-if="this.IsNegecioEscola" v-model="cursoSelected" :rules="ruleRequired"
                            outlined filled item-value="idCurso" item-text="descricao" :items="cursos"
                            @change="loadclasse()" chips label="Selecione o Curso"></v-combobox>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-combobox v-if="this.IsNegecioEscola" v-model="classeSelected" :rules="ruleRequired"
                            item-value="pkAnoacademico" item-text="descricao" :items="classesFiltered" chips
                            :label="(nivelEnsino === 1) ? 'Selecione o ano acadêmico' : 'Selecione a classe'"
                            return-object outlined filled></v-combobox>
                        </v-col>

                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn style="color:white;" color="green darken-1" :disabled="!valid1 || !valid || !valid2"
                    @click="saveProduto()">Submeter</v-btn>
                  <v-btn @click="tab = 1">Voltar</v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <!-- ================ FIM - PREÇOS ======================================= -->
          </v-tabs-items>
        </v-card>
      </div>
    </div>
  </div>
</template>
My CRUD
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import utilitarios from '../../plugins/utilitarios'
import Swal from 'sweetalert2'
const numero = require('numero-por-extenso')
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    definirPrecoPeriodo: [
      { id: 1, descricao: 'Mesmo valor por período' },
      { id: 2, descricao: 'Diferentes valores por períodos' }
    ],
    definirPrecoPeriodoSelected: null,
    isPrecoUnico: false,
    precoManha: 0,
    precoTarde: 0,
    precoNoite: 0,
    precoManhaDescricao: '',
    precoTardeDescricao: '',
    precoNoiteDescricao: '',
    isPrecoDiferente: false,
    valorDescricao: '',
    utilitarios: utilitarios,
    price: 0,
    overlayEmolumento: false,
    dialogInformativo: false,
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    tab: null,
    items: [
      { tab: 'Geral', disabilita: false, content: 'Tab 1 Content', id: 0 },
      { tab: 'Preços', disabilita: false, content: 'Tab 2 Content', id: 1 },
      { tab: 'Configurações adicionais', disabilita: false, content: 'Tab 2 Content', id: 3 }
    ],
    msgAlert: '',
    alert: false,
    colorAlert: 'red',
    iconAlert: 'done',
    alertType: 'success',
    descricaoEmolumento: '',
    valor: '',
    custoCompra: '',
    overlay: false,
    dialogEmolumento: false,
    Precoautomatico: false,
    precoSemIvaMargem: 0,
    produtosSubstitutos: [],
    definirSubstituto: '',
    margemPrecoAutomatico: 0,
    disabledPrecoFields: false,
    codigoRepetido: false,
    personalizar: false,
    especificacaoProdutoSelected: null,
    DefinirPrecoVendaSelected: null,
    tipoProdutoSelected: null,
    emolumentoSelected: null,
    mercadoriaSelected: null,
    familiaSelected: null,
    mercadoria_disable: false,
    taxa_ivaPrecoSelected: null,
    taxaIvaCompraSelected: null,
    taxaIvaVendaSelected: null,
    disabilita_ivaPreco: false,
    disabilita_ivaVenda: false,
    disabilita_ivaCompra: false,
    tipoPrecoSelecionada: null,
    controleStockSelected: null,
    codigoProduto: null,
    descricaoProduto: null,
    precoComIvaInteiro: null,
    codigoBarraSelected: '',
    descricaoReduzida: '',
    armazemSelected: '',
    motivoIsencao: '',
    margemPreco: '',
    precoSemIva: 0,
    precoComIva: '',
    precoCustoSelected: '',
    isServicoSelected: false,
    disabledStocksFields: true,
    predifinido: false,
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: 'Nº do Bi',
    valorIva: '0',
    validg: true,
    valid1: false,
    valid: false,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    imageData: '',
    turmasAll: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    armazem: [],
    taxa_iva: [],
    familiaProduto: [],
    mercadorias: [],
    tipoProdutos: [],
    descricao_isencao_ivaprecoFiltered: [],
    descricao_isencao_compraFiltered: [],
    descricao_isencao_ivaFiltered: [],
    descricao_isencao_iva: [],
    municipiosFiltered: [],
    mercadoriasFiltered: [],
    precosExtensao: [],
    tabelas_preco: [],
    produtoSubstitutoModel: [],
    model: [],
    cursos: [],
    classes: [],
    classesFiltered: [],
    emolumentos: [],
    searchInDb: '',
    classeSelected: null,
    cursoSelected: null,
    stockMinimo: null,
    stockMaximo: null,
    unidadeSelecionada: null,
    search: null,
    showFieldPreco: true,
    disableMargem: true,
    estudantes: [],
    servicos: [],
    dialogGrupo: false,
    valid2: false,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    controleStock: [
      { id: 1, descricao: 'Não' },
      { id: 2, descricao: 'Sim' }
    ],
    DefinirPrecoVenda: [
      { id: 1, descricao: 'Não' },
      { id: 2, descricao: 'Sim' }
    ],
    especificacao:
      [
        { id: 1, descricao: 'Venda Normal' },
        { id: 2, descricao: 'Oferta' }
      ],
    Unidades: [
      { id: 1, descricao: 'Unidade' },
      { id: 2, descricao: 'Kg' }
    ],
    TipoPrecoVenda: [
      { id: 1, descricao: 'Manual' },
      { id: 2, descricao: 'Automático' }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleText: [value => !!value || 'campo obrigatorio', value => {
      const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
      return !pattern.test(value) || 'Invalido.'
    }],
    ruleEmpty: [

    ],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 100 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],

    rulePrecoVenda: [
      value => {
        const valorInteiro = utilitarios.MoneyValueToInteger(value)
        return valorInteiro >= 0 || 'O Preço de venda não deve ser negativo.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleNumberNObrigatorio: [
      value => {
        const pattern = /^[0-9]+([,.][0-9]+)?$/g
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Preço descrição',
        align: 'start',
        sortable: false,
        value: 'name'
      },
      { text: 'Margem', value: 'calories' },
      { text: 'Preço sem IVA', value: 'fat' },
      { text: 'IVA', value: 'carbs' },
      { text: 'Modo de isenção', value: 'protein' },
      { text: 'Preço com IVA', value: 'iron' },
      { text: 'Stock Mínimo', value: 'stock_min' },
      { text: 'Stock Máximo', value: 'stock_max' },
      { text: 'Predifinido', value: 'iron' }
    ],
    headersPreco: [
      {
        text: 'Preço descrição',
        align: 'start',
        sortable: false,
        value: 'descricaoPreco'
      },
      { text: 'Margem', value: 'margem' },
      { text: 'Preço sem IVA', value: 'precoSemIva' },
      { text: 'IVA', value: 'iva' },
      { text: 'Modo de isenção', value: 'motivoIsencao' },
      { text: 'Preço com IVA', value: 'precoComIva' },
      { text: 'Stock Mínimo', value: 'stock_min' },
      { text: 'Stock Máximo', value: 'stock_max' },
      { text: 'Predifinido', value: 'predifinido' }
    ],
    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editeItemGrupo: {
      codigo: '',
      descricao: '',
      pkGrupo: 0
    }
  }),

  computed: {
    isAdmin() {
      return ls.get('nivel_user') == 1;
    },

    formTitle() {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName() {
      return ls.get('nomeUsuario')
    },
    idclasse() {
      return this.$store.state.idclasse
    },
    computeddatanascimento() {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns() {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },

    IsNegecioEscola(){
      return ls.get('fkNegocio') === 12
    },

    textMessage() {
      return this.$store.state.textMessage
    },
    classMessage() {
      return this.$store.state.classMessage
    },
    hasMessage() {
      return this.$store.state.hasMessage
    },

    ListaActividades() {
      return ls.get('lista_actividades')
    },

    returnImagem() {
      return this.imageData
    },

    regime_id() {
      return ls.get('regime')
    },

    regime() {
      return ls.get('regime_descricao')
    },

    id_negocio() {
      return ls.get('id_negocio')
    },
    negocio() {
      return ls.get('negocio')
    },
    isEscola() {
      return this.IsNegecioEscola
    },

    nivelEnsino() {
      return ls.get('nivel')
    },
    anolectivo() {
      return ls.get('anolectivo')
    }

  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes() {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog(val) {
      val || this.close()
    },
    model(val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },

    isAdm() {
      return ls.get('role') === 'ROLE_ADM'
    },

    tab(val) {
      console.log(val)
    }
  },

  created() {
    this.initializeTipoProdutos()
    this.initializeMercadoria()
    this.initializeArmazem()
    this.initializeFamiliaProduto()
    this.initializeTaxaIva()
    this.initializeIsencaoIva()
    this.initializePrecosDescricao()
    this.unidadeSelecionada = this.Unidades[0]
    this.tipoPrecoSelecionada = this.TipoPrecoVenda[0]
    this.DefinirPrecoVendaSelected = this.DefinirPrecoVenda[1]
    if (this.isEscola) {
      this.initializeCursos()
      //this.initializeClasses()
      this.initializeEmolumentos()
    }


  },

  methods: {
     async initializeTipoProdutos() {
       this.isLoading = true;
      try {
        this.tipoProdutos = await axios.get('/tipoProdutoFindall').then(res => res.data)
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar ' )
      }
    }, // combo qua depende de outra combo


    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },

    async initializeEmolumentos() {
      try {
        this.isLoading = true
        this.emolumentos = await axios.get('/emolumentosFindAll').then(res => res.data)
        this.emolumentos.unshift({ descricao: 'Novo Emolumento', id: -1, icone: true })
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally { this.isLoading = false }
    },

    async initializeCursos() {
      try {
        this.isLoading = true
        this.cursos = await axios.get('/cursoInstituicaoFindAllIntegracao').then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally { this.isLoading = false }
    },

    async initializeClasses() {
      try {
        this.isLoading = true
        this.classes = await axios.get('/anoacademicoFindAll').then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally { this.isLoading = false }
    },

    loadclasse() {
      /**
       * Nivel Ensino
       * 1 - Superioor
       * 2 - Médio
       */
      if (this.nivelEnsino === 1) {
        for (let index = 1; index <= parseInt(this.cursoSelected.numero_anos_academicos); index++) {
          this.classesFiltered.push({ id: index, descricao: index + 'º ano' })
        }
        this.classesFiltered.unshift({ pkAnoacademico: -1, descricao: 'Todos os anos' })
        this.classesFiltered.push({ id: 100, descricao: 'Monografia' })
      } else {
        let classe = 10
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({ id: index, descricao: classe + 'ª Classe' })
          classe++;
        }
        this.classesFiltered.unshift({ pkAnoacademico: -1, descricao: 'Todas as classes' })
      }
    },




   
    async initializeMercadoria() {
      try {
        //   let  payload =""
        this.isLoading = true
        this.mercadorias = await axios
          .get('/mercadoriaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb


    SelecionaEmolumento() {
      if (this.emolumentoSelected.id === -1) {
        this.dialogEmolumento = true
        this.emolumentoSelected = null
      } else {
        this.descricaoReduzida = this.emolumentoSelected.descricao
        this.descricaoProduto = this.emolumentoSelected.descricao
      }

    },

    async CarregaProdutos() {
      try {
        //   let  payload =""
        this.overlay = true
        this.produtosSubstitutos = await axios
          .get('/produtosFindall-substituto')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeArmazem() {
      try {
        //   let  payload =""
        this.isLoading = true
        this.armazem = await axios
          .get('/armazemFindall')
          .then(res => res.data)
        console.log(this.armazem)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeFamiliaProduto() {
      try {
        //   let  payload =""
        this.isLoading = true
        this.familiaProduto = await axios
          .get('/FamiliaProdutoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    async initializeTaxaIva() {
      try {
        //   let  payload =""
        this.isLoading = true
        this.taxa_iva = await axios
          .get('/TaxaIvaFindall')
          .then(res => res.data)

        // this.taxa_ivaPrecoSelected = this.taxa_iva[0]
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeIsencaoIva() {
      try {
        //   let  payload =""
        this.isLoading = true
        this.descricao_isencao_iva = await axios
          .get('/IsencaoIvaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async VerificaCodigoExistente() {
      try {
        //   let  payload =""
        this.isLoading = true
        let result = await axios
          .get('/verificaCodigoBarra/' + this.codigoBarraSelected)
          .then(res => res.data)
        if (result.length) {
          this.codigoRepetido = true
          Swal.fire('Código de barra já existente.', '', 'warning')
        } else {
          this.codigoRepetido = false
        }
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializePrecosDescricao() {
      try {
        //   let  payload =""
        this.isLoading = true
        this.precosExtensao = await axios
          .get('/precosExtensaoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    async SaveGrupo() {
      if (this.$refs.formg.validate()) {
        let params =
        {
          pkFamilia: 0,
          descricao: this.editeItemGrupo.descricao,
          codigo: this.editeItemGrupo.codigo
        }

        try {
          //   let  payload =""
          this.isLoading = true
          let result = await axios
            .post('/FamiliaInsertUpdate', params)
            .then(res => res.data)
          if (result.affectedRows >= 0) {
            this.initializeFamiliaProduto().then(() => {
              this.familiaSelected = this.familiaProduto[this.familiaProduto.length - 1]
              this.dialogGrupo = false
              this.editeItemGrupo.codigo = ''
              this.editeItemGrupo.descricao = ''
            })
          }
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    Continuar() {
      if (this.$refs.form.validate()) {
        this.tab = 1
      }
    },

    Continuar2() {
      if (!this.definirPrecoPeriodoSelected) {
        Swal.fire('Informação', 'Definir o tipo de preço por período!', 'info')
      } else {
        if (this.$refs.form1.validate()) {
          this.tab = 2
        }
      }
    },

    TabIndexToZero(id) {

    },

    SelecionaUnidade() {

    },



    SelecionaIvaVenda() {
      if (this.taxaIvaVendaSelected !== null) {
        if (this.taxaIvaVendaSelected === 0) {
          this.descricao_isencao_ivaFiltered = this.descricao_isencao_iva
          this.disabilita_ivaVenda = false
        } else {
          this.disabilita_ivaVenda = true
          this.descricao_isencao_ivaFiltered = []
        }
      }
    },

    SelecionaControleStock() {
      if (this.controleStockSelected === 1) {
        this.disabledStocksFields = true
      } else {
        this.disabledStocksFields = false
      }
    },

    SelecionaDefinirPrecoVenda() {
      if (this.DefinirPrecoVendaSelected === 1) {
        this.disabledPrecoFields = true
        this.showFieldPreco = false
        // Faz o reset da combobox de seleção do calculo do preço
        this.disableMargem = true
        this.tipoPrecoSelecionada = this.TipoPrecoVenda[0]
        // Faz o reset da combobox --- Fim
        this.LimpaCamposPreco()
      } else if (this.DefinirPrecoVendaSelected === 2) {
        this.disabledPrecoFields = false
        this.showFieldPreco = true
      }
    },

    SelecionaDefinirPrecoPeriodo() {
      this.limparPrecos();
      if (this.definirPrecoPeriodoSelected === 1) {
        this.isPrecoDiferente = false;
        this.isPrecoUnico = true;
      } else if (this.definirPrecoPeriodoSelected === 2) {

        this.isPrecoUnico = false;
        this.isPrecoDiferente = true;
      }
    },

    limparPrecos() {
      this.precoSemIva = '';
      this.precoComIva = '';
      this.valorDescricao = '';
      this.precoManha = '';
      this.precoManhaDescricao = '';
      this.precoTarde = '';
      this.precoTardeDescricao = '';
      this.precoNoite = '';
      this.precoNoiteDescricao = '';
    },

    showDialogGrupo() {
      this.editeItemGrupo.codigo = this.descricaoProduto
      this.dialogGrupo = true
    },

    ObterPrecoDescricao() {
      let result = utilitarios.MoneyValueToInteger(this.precoSemIva)
      if (result <= 0) {
        this.valorDescricao = ''
        this.precoComIva = ''
      } else {
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.valorDescricao = valor + ' Kwanza(s)'
        if (this.regime_id !== 1) {
          this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
          let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoSemIva), this.taxa_ivaPrecoSelected)
          this.valorIva = iva
        }
      }
    },

    ObterPrecoDescricaoManha() {
      let result = utilitarios.MoneyValueToInteger(this.precoManha)
      if (result <= 0) {
        this.precoManhaDescricao = ''
        this.precoManha = ''
      } else {
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.precoManhaDescricao = valor + ' Kwanza(s)'
        if (this.regime_id !== 1) {
          this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
          let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoManha), this.taxa_ivaPrecoSelected)
          this.valorIva = iva
        }
      }
    },

    ObterPrecoDescricaoTarde() {
      let result = utilitarios.MoneyValueToInteger(this.precoTarde)
      if (result <= 0) {
        this.precoTardeDescricao = ''
        this.precoTarde = ''
      } else {
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.precoTardeDescricao = valor + ' Kwanza(s)'
        if (this.regime_id !== 1) {
          this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
          let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoTarde), this.taxa_ivaPrecoSelected)
          this.valorIva = iva
        }
      }
    },

    ObterPrecoDescricaoNoite() {
      let result = utilitarios.MoneyValueToInteger(this.precoNoite)
      if (result <= 0) {
        this.precoNoiteDescricao = ''
        this.precoNoite = ''
      } else {
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.precoNoiteDescricao = valor + ' Kwanza(s)'
        if (this.regime_id !== 1) {
          this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
          let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoNoite), this.taxa_ivaPrecoSelected)
          this.valorIva = iva
        }
      }
    },

    SelecionaIvaCompra() {
      if (this.taxaIvaCompraSelected !== null) {
        if (this.taxaIvaCompraSelected === 0) {
          this.descricao_isencao_compraFiltered = this.descricao_isencao_iva
          this.disabilita_ivaCompra = false
        } else {
          this.disabilita_ivaCompra = true
          this.descricao_isencao_compraFiltered = []
        }
      }
    },

    SelecionaIvaPreco() {
      if (this.taxa_ivaPrecoSelected !== null) {
        if (this.taxa_ivaPrecoSelected === 0) {
          this.descricao_isencao_ivaprecoFiltered = this.descricao_isencao_iva
          this.disabilita_ivaPreco = false
        } else {
          this.disabilita_ivaPreco = true
          this.descricao_isencao_ivaprecoFiltered = []
        }
        this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
        let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoSemIva), this.taxa_ivaPrecoSelected)
        this.valorIva = iva
      }
    },

    SelecionaEspecProduto() {
      if (this.especificacaoProdutoSelected.id === 0) {
        this.precoComIvaInteiro = 0
        this.precoSemIva = 0
        this.margemPreco = 0
        this.taxa_ivaPrecoSelected = 0
        this.valorDescricao = 'Zero Kwanza'
      }
    },
    // METHODO FOR VALIDATION
    validate() {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset() {
      this.$refs.form.reset()
      this.Limpar()
    },

    reset2() {
      this.$refs.form.resetValidation()
      this.LimparSelected()
    },
    resetValidation() {
      this.$refs.form.reset()
    },

    SelecionaTipoServico() {
      if (this.tipoProdutoSelected !== null) {
        this.mercadoriasFiltered = this.mercadorias.filter(f => f.fk_tipoProduto === this.tipoProdutoSelected)
        if (this.tipoProdutoSelected == 2 || this.tipoProdutoSelected == 3) // Selecionou um serviço
        {
          this.reset2()
          this.isServicoSelected = true
          this.armazemSelected = 3 // set os valores default
          this.mercadoriaSelected = 7 // set os valores default
          this.familiaSelected = 5 // set os valores default
        }
        else
          this.isServicoSelected = false
      }
    },
    savePreco() {
      if (this.$refs.form.validate()) {
        let params =
        {
          descricaoPreco: this.valorDescricao,
          margem: this.margemPreco,
          precoSemIva: this.precoSemIva,
          iva: this.taxa_ivaPrecoSelected,
          motivoIsencao: this.motivoIsencao,
          predifinido: this.predifinido,
          precoComIva: this.precoComIva
        }

        this.tabelas_preco.push(params)
        this.dialog = false
      }
    },

    async saveEmolumento() {
      if (this.$refs.form.validate()) {
        let emolumentoExistente = this.emolumentos.filter(e => e.descricao.toLowerCase() === this.descricaoEmolumento.toLowerCase())
        if (emolumentoExistente.length) {
          Swal.fire('Informação', 'Emolumento já existente.', 'info')
        } else {
          this.overlayEmolumento = true
          try {
            let result = await this.cadastrarEmolumento({ descricao: this.descricaoEmolumento })
            if (result.affectedRows >= 1) {
              Swal.fire('Informação', 'Emolumento guardado com sucesso', 'success')
              this.initializeEmolumentos()
              this.emolumentoSelected = ''
              this.overlayEmolumento = false
              this.dialogEmolumento = false
            }
          } catch (error) {
            Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a opeeração', 'error')
          }
        }
      }
    },

    async cadastrarEmolumento(params) {
      return axios.post('/registrarDescricaoEmolumento', params).then((res) => res.data)
    },

    CalculoPrecoVenda() {
      if (this.tipoPrecoSelecionada === 1) {
        this.disableMargem = true
        this.Precoautomatico = false
      } else {
        this.disableMargem = false
        this.Precoautomatico = true
      }
    },

    async saveProduto() {
      if (this.$refs.form1.validate() && this.$refs.form.validate() && this.$refs.form2.validate()) {
        // Definição das variaveis
        //this.overlay = true
        let precoVenda = (this.Precoautomatico) ? this.precoSemIvaMargem : this.precoSemIva ? this.precoSemIva : utilitarios.MoneyValueToInteger(this.precoManha);
        if (this.definirPrecoPeriodoSelected === 1) {
          this.precoManha = precoVenda;
          this.precoTarde = precoVenda;
          this.precoNoite = precoVenda;
          this.precoNoiteDescricao = this.valorDescricao;
          this.precoTardeDescricao = this.valorDescricao;
          this.precoManhaDescricao = this.valorDescricao;
        } else {
          this.precoComIva = utilitarios.MoneyValueToInteger(this.precoManha)
        }


        let params = {
          descricao: this.descricaoProduto,
          descricaoReduzida: this.descricaoReduzida,
          codigoBarra: this.codigoBarraSelected,
          armazem: this.armazemSelected,
          tipoProduto: this.tipoProdutoSelected,
          mercadoria: this.mercadoriaSelected,
          familia: (this.isEscola) ? null : ((this.familiaSelected.pkFamiliaProduto !== undefined) ? this.familiaSelected.pkFamiliaProduto : this.familiaSelected),
          isencao: this.motivoIsencao,
          pkProduto: 0,
          especificacaoProduto: this.especificacaoProdutoSelected,
          stockMinimo: (this.controleStockSelected === 1) ? null : this.stockMinimo,
          stockMaximo: (this.controleStockSelected === 1) ? null : this.stockMaximo,
          unidade: this.unidadeSelecionada,
          controleStock: this.controleStockSelected,
          substituto: (this.produtoSubstitutoModel.length) ? this.produtoSubstitutoModel : '',
          curso: this.cursoSelected,
          classe: this.classeSelected,
          classes: this.classesFiltered,
          idEmolumento: this.emolumentoSelected.id,
          precoComIva: this.precoComIvaInteiro ? this.precoComIvaInteiro : this.precoComIva,
          precoComIvaTarde: utilitarios.MoneyValueToInteger(this.precoTarde),
          precoComIvaNoite: utilitarios.MoneyValueToInteger(this.precoNoite),
          precoSemIva: (this.DefinirPrecoVendaSelected === 1) ? null : ((precoVenda !== 0) ? utilitarios.MoneyValueToInteger(precoVenda) : 0),
          precoSemIvaTarde: (this.DefinirPrecoVendaSelected === 1) ? null : ((this.precoTarde !== 0) ? utilitarios.MoneyValueToInteger(this.precoTarde) : 0),
          precoSemIvaNoite: (this.DefinirPrecoVendaSelected === 1) ? null : ((this.precoNoite !== 0) ? utilitarios.MoneyValueToInteger(this.precoNoite) : 0),
          margem: (this.Precoautomatico) ? this.margemPrecoAutomatico : this.margemPreco,
          iva: this.taxa_ivaPrecoSelected,
          descricaoPreco: this.valorDescricao,
          precoVendaDefinido: this.DefinirPrecoVendaSelected,
          CalculoPrecoVenda: this.tipoPrecoSelecionada,
          precoPorPeriodo: this.definirPrecoPeriodoSelected,
          anolectivo: this.anolectivo
        }


        try {
          let msg = await axios.post('/produtoAdd', params).then(res => res.data);
          if (msg.affectedRows !== undefined) {
            if (msg.affectedRows >= 1) {
              Swal.fire((this.IsNegecioEscola) ? 'Emolumento registrado com sucesso' : 'Produto registrado com sucesso', '', 'success')
              this.tab = 0

            } else {
              Swal.fire('Ocorreu um erro ao tentar registrar o Produto!', '', 'warning')
              this.tab = 0
            }
          } else if (msg.sqlMessage !== undefined) {
            Swal.fire('Ocorreu um erro ao tentar registrar o Produto!', '', 'warning')
            this.tab = 0
          }
        } catch (error) {          
          let mensagemErro = error.toString();
          if (mensagemErro.includes('status code 409')) {
            Swal.fire('Informação', 'É possivél que emolumento já tenha sido registrado pra o curso ou algum ano lectivo selecionado! Consulte a lista do emolumento cadastrados.', 'warning')
          } else {
            Swal.fire('Informação', 'Ocorreu um erro durante o cadastro!', 'error')
          }
        } finally {
          this.overlay = false
        }
      }
    },

    Limpar() {
      this.descricaoProduto = ''
      this.descricaoReduzida = ''
      this.armazemSelected = ''
      this.tipoProdutoSelected = ''
      this.mercadoriaSelected = ''
      this.familiaSelected = ''
      this.tabelas_preco = []
      this.produtoSubstitutoModel = []
    },

    LimparSelected() {
      this.armazemSelected = ''
      this.mercadoriaSelected = ''
      this.familiaSelected = ''
      this.tabelas_preco = []
      this.produtoSubstitutoModel = []
    },

    LimpaCamposPreco() {
      this.precoComIva = ''
      this.precoComIvaInteiro = ''
      this.precoSemIvaMargem = ''
      this.precoSemIva = ''
      this.valorDescricao = ''
      this.margemPrecoAutomatico = ''
      this.margemPreco = ''
      this.motivoIsencao = ''
      this.taxa_ivaPrecoSelected = ''
      this.margem = ''
    },

    CalculaPreComIva(valor) {
      let Preco = (!this.disableMargem) ? this.precoSemIvaMargem : this.precoSemIva
      let valorIva = ((Preco === 0) ? 0 : utilitarios.MoneyValueToInteger(Preco)) * valor
      let valorFinal = ((Preco === 0) ? 0 : utilitarios.MoneyValueToInteger(Preco)) + valorIva
      this.precoComIva = valorFinal
      this.precoComIva = this.ObterValorFormatado(valorFinal)
      this.precoComIvaInteiro = valorFinal
    },

    CalculoPrecoVendaAutomatico() {
      let CustoDouble = utilitarios.MoneyValueToInteger(this.custoCompra)
      let lucro = (CustoDouble * this.margemPrecoAutomatico) / 100
      let PrecoVendaCalculado = CustoDouble + lucro
      this.precoSemIvaMargem = utilitarios.IntegerToMoneyValue(PrecoVendaCalculado)
      this.PrecoDescricao(this.precoSemIvaMargem)
    },

    PrecoDescricao(preco) {
      let result = utilitarios.MoneyValueToInteger(preco)
      let valor = numero.porExtenso(result)
      valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
      this.valorDescricao = valor + ' Kwanza(s)'
    },

    ObterValorFormatado(valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      return formated.toString().replace('AOA', '')
    }
  }
}
</script>
<style scoped>
.info_adm_container {
  text-align: center;
  padding: 40px;
  font-family: sans-serif;
}

.btn_space {
  margin-bottom: 5px;
}

.btn_add_align {
  margin-top: 10px;
}

.file-upload-form,
.image-preview {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 20px;
}

img.preview {
  background-color: white;
  border: 1px solid #DDD;
  padding: 5px;
}
</style>
